import en from './en.json'
import th from './th.json'
import zh from './zh.json'
import id from './id.json'
import vi from './vi.json'

export default {
  en,
  th,
  zh,
  id,
  vi,
}



// WEBPACK FOOTER //
// ./src/lang/index.js